export default __webpack_public_path__ + "static/media/arrrow-icon.efda7cc2.webp";